"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Text = _interopRequireDefault(require("../Text"));

var _HotelOrdersCard = _interopRequireDefault(require("../HotelOrdersCard"));

var _constant = require("./constant");

var _Label = _interopRequireDefault(require("../Label"));

var _HotelOrdersListing = require("./HotelOrdersListing.proptypes");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var MainWrapper = _styledComponents.default.table.withConfig({
  displayName: "HotelOrdersListing__MainWrapper",
  componentId: "sc-14vqvp3-0"
})(["width:100%;border-collapse:collapse;"]);

var TableBody = _styledComponents.default.tbody.withConfig({
  displayName: "HotelOrdersListing__TableBody",
  componentId: "sc-14vqvp3-1"
})([""]);

var RowWrapperAction = _styledComponents.default.tr.withConfig({
  displayName: "HotelOrdersListing__RowWrapperAction",
  componentId: "sc-14vqvp3-2"
})(["border-bottom:", ";cursor:pointer;"], function (_ref) {
  var theme = _ref.theme,
      bottomBorder = _ref.bottomBorder;
  return bottomBorder ? "1px solid ".concat(theme.colors.greyLight) : '';
});

var ContentWrapper = _styledComponents.default.td.withConfig({
  displayName: "HotelOrdersListing__ContentWrapper",
  componentId: "sc-14vqvp3-3"
})(["font-family:", ";font-size:", ";font-weight:", ";line-height:", ";color:", ";background-color:", ";padding:", ";text-align:", ";white-space:", ";overflow:", ";text-overflow:", ";max-width:", ";span{font-size:", ";font-weight:", ";color:", ";}"], function (_ref2) {
  var theme = _ref2.theme,
      family = _ref2.family;
  return theme.fontFamily[family];
}, function (_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size;
  return theme.fontSize[size];
}, function (_ref4) {
  var theme = _ref4.theme,
      weight = _ref4.weight;
  return theme.fontWeight[weight];
}, function (_ref5) {
  var theme = _ref5.theme,
      height = _ref5.height;
  return theme.lineHeight[height];
}, function (_ref6) {
  var theme = _ref6.theme,
      color = _ref6.color;
  return theme.colors[color];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.backgroundColor.default;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.XSmall, " ").concat(theme.space.standard);
}, function (_ref9) {
  var alignment = _ref9.alignment;
  return alignment;
}, function (_ref10) {
  var isEllipsis = _ref10.isEllipsis;
  return isEllipsis ? 'nowrap' : '';
}, function (_ref11) {
  var isEllipsis = _ref11.isEllipsis;
  return isEllipsis ? 'hidden' : '';
}, function (_ref12) {
  var isEllipsis = _ref12.isEllipsis;
  return isEllipsis ? 'ellipsis' : '';
}, function (_ref13) {
  var isEllipsis = _ref13.isEllipsis,
      ellipsisLength = _ref13.ellipsisLength;
  return isEllipsis ? ellipsisLength : null;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.fontSize.XSmall;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeight.normal;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.greyDark;
});

var HotelWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelOrdersListing__HotelWrapper",
  componentId: "sc-14vqvp3-4"
})(["display:flex;flex-direction:row;justify-content:left;align-items:center;"]);

var HotelLocation = _styledComponents.default.div.withConfig({
  displayName: "HotelOrdersListing__HotelLocation",
  componentId: "sc-14vqvp3-5"
})(["display:flex;flex-direction:row;justify-content:left;align-items:center;"]);

var HotelOrdersListing = function HotelOrdersListing(props) {
  var theme = props.theme,
      translation = props.translation,
      accessible = props.accessible,
      customProperties = props.customProperties,
      columns = props.columns,
      data = props.data,
      isMobile = props.isMobile,
      isEllipsis = props.isEllipsis,
      handleClick = props.handleClick,
      active = props.active,
      ellipsisLength = props.ellipsisLength,
      onOptionSelect = props.onOptionSelect,
      pastBooking = props.pastBooking;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);

  var getContentWrapperProps = function getContentWrapperProps(textType, isLastColumn) {
    return {
      family: textType.fontFamily,
      size: textType.fontSize,
      weight: textType.fontWeight,
      height: textType.lineHeight,
      color: textType.fontColor,
      alignment: isLastColumn ? _constant.ALIGNMENT.right : _constant.ALIGNMENT.left,
      isEllipsis: isEllipsis,
      ellipsisLength: ellipsisLength
    };
  };

  var getRowsWithAction = function getRowsWithAction() {
    return data.map(function (rowKey, rowIdx) {
      var rowData = data[rowIdx];
      var keys = Object.keys(rowData.columns);
      var row = rowData.columns;
      return /*#__PURE__*/_react.default.createElement(RowWrapperAction, {
        bottomBorder: rowIdx === data.length - 1 ? true : rowData.bottomBorder,
        onClick: function onClick() {
          handleClick(rowData.actions);
        }
      }, keys.map(function (key, idx) {
        var _cellData$icon, _cellData$icon2, _cellData$locationIco, _cellData$locationIco2;

        var headerData = columns.find(function (o) {
          return o.columnKey === key;
        });
        var textType = JSON.parse(JSON.stringify(_constant.TEXT_TYPE.text));
        var isLastColumn = idx === columns.length - 1;
        var cellData = row[key] || '';
        textType.fontColor = (headerData === null || headerData === void 0 ? void 0 : headerData.fontColor) || '';
        textType.fontSize = (headerData === null || headerData === void 0 ? void 0 : headerData.fontSize) || textType.fontSize;
        var type = headerData === null || headerData === void 0 ? void 0 : headerData.type;

        if (type === _constant.CELL_TYPE.label) {
          // eslint-disable-next-line no-const-assign
          isLastColumn = true;
        }

        return /*#__PURE__*/_react.default.createElement(ContentWrapper, getContentWrapperProps(textType, isLastColumn), type === _constant.CELL_TYPE.simple && (rowData !== null && rowData !== void 0 && rowData.hideDate ? '' : language[cellData] || cellData), type === _constant.CELL_TYPE.pair && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, " ", language[cellData === null || cellData === void 0 ? void 0 : cellData.key] || (cellData === null || cellData === void 0 ? void 0 : cellData.key), " "), /*#__PURE__*/_react.default.createElement("div", null, " ", language[cellData === null || cellData === void 0 ? void 0 : cellData.value] || (cellData === null || cellData === void 0 ? void 0 : cellData.value), " ")), type === _constant.CELL_TYPE.label && /*#__PURE__*/_react.default.createElement(_Label.default, {
          labelColor: cellData === null || cellData === void 0 ? void 0 : cellData.label,
          textColor: cellData === null || cellData === void 0 ? void 0 : cellData.fontColor
        }, language[cellData === null || cellData === void 0 ? void 0 : cellData.value] || (cellData === null || cellData === void 0 ? void 0 : cellData.value)), type === _constant.CELL_TYPE.action && /*#__PURE__*/_react.default.createElement(_Icon.default, {
          icon: cellData === null || cellData === void 0 ? void 0 : cellData.name,
          fontsize: cellData === null || cellData === void 0 ? void 0 : cellData.fontSize
        }), type === _constant.CELL_TYPE.hotel && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HotelWrapper, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          icon: cellData === null || cellData === void 0 || (_cellData$icon = cellData.icon) === null || _cellData$icon === void 0 ? void 0 : _cellData$icon.name,
          fontsize: cellData === null || cellData === void 0 || (_cellData$icon2 = cellData.icon) === null || _cellData$icon2 === void 0 ? void 0 : _cellData$icon2.fontSize
        })), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            paddingLeft: '15px'
          }
        }, /*#__PURE__*/_react.default.createElement(_Text.default, {
          bold: !pastBooking,
          color: pastBooking ? _constant.COLOR.greyDark : _constant.COLOR.neutral
        }, language[cellData === null || cellData === void 0 ? void 0 : cellData.name] || (cellData === null || cellData === void 0 ? void 0 : cellData.name)), !pastBooking && /*#__PURE__*/_react.default.createElement(HotelLocation, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
          icon: cellData === null || cellData === void 0 || (_cellData$locationIco = cellData.locationIcon) === null || _cellData$locationIco === void 0 ? void 0 : _cellData$locationIco.name,
          fontsize: cellData === null || cellData === void 0 || (_cellData$locationIco2 = cellData.locationIcon) === null || _cellData$locationIco2 === void 0 ? void 0 : _cellData$locationIco2.fontSize
        }), /*#__PURE__*/_react.default.createElement(_Text.default, {
          color: _constant.TEXT_TYPE.small.fontColor,
          type: _constant.TEXT_TYPE.small.fontSize
        }, language[cellData === null || cellData === void 0 ? void 0 : cellData.location] || (cellData === null || cellData === void 0 ? void 0 : cellData.location)))))));
      }));
    });
  };

  var getMain = function getMain() {
    if (!isMobile) {
      return /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({
        tabIndex: tabIndex,
        isActive: active
      }, customProperties), /*#__PURE__*/_react.default.createElement(TableBody, null, getRowsWithAction()));
    }

    return /*#__PURE__*/_react.default.createElement(MainWrapper, (0, _extends2.default)({
      tabIndex: tabIndex
    }, customProperties), data.map(function (HotelData) {
      return /*#__PURE__*/_react.default.createElement(_HotelOrdersCard.default // eslint-disable-next-line max-len
      , {
        key: "".concat(HotelData.columns.date, "+").concat(HotelData.bottomBorder, "+").concat(HotelData.hideDate),
        accessible: accessible,
        theme: theme,
        isMobile: isMobile,
        translation: translation,
        data: HotelData,
        onOptionSelect: onOptionSelect,
        handleClick: handleClick,
        pastBooking: pastBooking
      });
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

HotelOrdersListing.propTypes = _HotelOrdersListing.HotelOrdersListingPropTypes.PropTypes;
HotelOrdersListing.defaultProps = _HotelOrdersListing.HotelOrdersListingPropTypes.DefaultProps;
var _default = HotelOrdersListing;
exports.default = _default;